import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 512 512' fill={fillColor} className={className}>
      <g>
        <g>
          <path d='M418.54,193.172H93.46c-17.235,0-31.258,14.022-31.258,31.258v256.313C62.203,497.978,76.225,512,93.46,512H418.54 c17.235,0,31.258-14.022,31.258-31.258V224.43C449.797,207.194,435.775,193.172,418.54,193.172z M412.288,474.491H99.712v-243.81 h312.576V474.491z' />
        </g>
      </g>
      <g>
        <g>
          <path d='M254.75,0c-54.132,0-104.882,31.551-129.3,80.382c-4.639,9.265-0.881,20.53,8.383,25.162 c9.271,4.639,20.53,0.875,25.162-8.383c18.117-36.234,55.707-59.652,95.586-59.652c59.383,0.531,107.695,49.606,107.695,109.402 v62.515c0,10.359,8.396,18.755,18.755,18.755s18.755-8.396,18.755-18.755v-62.515C399.785,66.616,334.801,0.713,254.75,0z' />
        </g>
      </g>
      <g>
        <g>
          <path d='M256,330.706c-10.359,0-18.755,8.396-18.755,18.755v43.761c0,10.359,8.396,18.755,18.755,18.755 s18.755-8.39,18.755-18.755V349.46C274.755,339.102,266.359,330.706,256,330.706z' />
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
